import Status from '@/components/status'
export default {
  name: 'view-detail',
  components: {Status},
  props: ['data'],
  data () {
    return {

    }
  },
  computed: {
    show () {
      return this.$store.getters['ChecklistItem/getOpenView']
    },
    options () {
      return this.$store.getters['Status/getStatusCheckerMaker']
    }
  },
  mounted () {
    this.$store.dispatch('Status/getListStatus')
  },
  methods: {
    approval (group_checklist_item = {}) {
      this.$loading.start()
      this.$store.dispatch('GroupChecklistItem/approvalGroupChecklistItem', {
        group_checklist_item
      }).then(res => {
        group_checklist_item.status = res.status
        this.$loading.complete()
      }).catch(errors => {
        console.log(errors)
        this.$loading.fail()
      })
    },

    rejection (group_checklist_item = {}) {
      this.$loading.start()
      this.$store.dispatch('GroupChecklistItem/rejectGroupChecklistItem', {
        group_checklist_item
      }).then(res => {
        group_checklist_item.status = res.status
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist-item/group-checklist-item/view-detail/view-detail.js